export const orchidPink = {
    orchidPink100: '#fcf9fa',
    orchidPink200: '#fbf3f5',
    orchidPink300: '#fde5ec',
    orchidPink400: '#fdd7e2',
    orchidPink500: '#f9c9d7',
    orchidPink600: '#f2b9ca',
    orchidPink700: '#e9a6bb',
    orchidPink800: '#df8da8',
    orchidPink900: '#b86a84',
    orchidPink1000: '#aa5e78',
    orchidPink1100: '#9d536d',
    orchidPink1200: '#601b37',
    orchidPinkAccentContrast: '#ffffff',
    orchidPinkAccentSurface: '#fbf3f6',
};

export const orchidPinkAlpha = {
    orchidPink100: 'rgba(252, 61, 125, 0.02)',
    orchidPink200: 'rgba(227, 23, 74, 0.04)',
    orchidPink300: 'rgba(255, 183, 204, 0.33)',
    orchidPink400: 'rgba(255, 141, 174, 0.33)',
    orchidPink500: 'rgba(237, 2, 71, 0.2)',
    orchidPink600: 'rgba(215, 1, 65, 0.27)',
    orchidPink700: 'rgba(197, 3, 64, 0.35)',
    orchidPink800: 'rgba(187, 2, 63, 0.44)',
    orchidPink900: 'rgba(135, 0, 45, 0.58)',
    orchidPink1000: 'rgba(121, 0, 42, 0.63)',
    orchidPink1100: 'rgba(111, 2, 40, 0.67)',
    orchidPink1200: 'rgba(77, 0, 31, 0.89)',
    orchidPinkAccentContrast: '#ffffff',
    orchidPinkAccentSurface: 'rgba(251, 241, 244, 0.8)',
};

export const orchidPinkDark = {
    orchidPink100: '#180e11',
    orchidPink200: '#211116',
    orchidPink300: '#3f0a21',
    orchidPink400: '#500a2a',
    orchidPink500: '#5d1834',
    orchidPink600: '#6c2742',
    orchidPink700: '#7b364f',
    orchidPink800: '#8a455c',
    orchidPink900: '#995369',
    orchidPink1000: '#a86176',
    orchidPink1100: '#b76f83',
    orchidPink1200: '#c67d90',
    orchidPinkAccentContrast: '#ffffff',
    orchidPinkAccentSurface: '#211116',
};

export const orchidPinkDarkAlpha = {
    orchidPink100: 'rgba(24, 14, 17, 0.01)',
    orchidPink200: 'rgba(33, 17, 22, 0.04)',
    orchidPink300: 'rgba(63, 10, 33, 0.11)',
    orchidPink400: 'rgba(80, 10, 42, 0.18)',
    orchidPink500: 'rgba(93, 24, 52, 0.24)',
    orchidPink600: 'rgba(108, 39, 66, 0.31)',
    orchidPink700: 'rgba(123, 54, 79, 0.38)',
    orchidPink800: 'rgba(138, 69, 92, 0.45)',
    orchidPink900: 'rgba(153, 83, 105, 0.7)',
    orchidPink1000: 'rgba(168, 97, 118, 0.65)',
    orchidPink1100: 'rgba(183, 111, 131, 0.83)',
    orchidPink1200: 'rgba(198, 125, 144, 0.96)',
    orchidPinkAccentContrast: '#ffffff',
    orchidPinkAccentSurface: 'rgba(33, 17, 22, 0.5)',
};
